<template>
  <div class="eventTerms custom-terms terms-ecs-2025">
    <div class="eventInformation">
      <v-container>
        <v-layout>
          <v-flex md8 xs12 class="terms" v-if="!viewOnly && !event">
            <h3>One moment please.</h3>
            <p>
              If this message persists, we may have encountered a problem.
              Please email <a href="mailto:amaze@rti.org">amaze@rti.org</a> and
              let us know.
            </p>
          </v-flex>
          <v-flex md8 xs12 class="terms" v-else>
            <h3>Waiver and Release Form</h3>

            <p>
              I, the undersigned ("Sponsor"), in consideration for my voluntary
              participation in the
              <strong v-if="event">{{ event }}</strong
              ><strong v-else>2026 Early College Summit</strong> on
              <strong v-if="event">{{ event_date }}</strong
              ><strong v-else>June 9-10, 2025</strong>, hosted by Research
              Triangle Institute, under the trade name RTI International (RTI)
              at the Benton Convention Center, 301 W. 5th Street, Winston-Salem,
              NC 27101 (“Conference”), do hereby willfully acknowledge that my
              electronic acceptance attests to my understanding and agreement
              that:
            </p>
            <h4>ADMITTANCE</h4>
            <p>
              In our sole discretion, without refund, RTI reserves the right to
              refuse admittance to or expel from the Conference anyone that we
              determine is behaving in a manner that could be disruptive to the
              Conference or any other.
            </p>
            <h4>PAYMENT TERMS</h4>
            <p>
              RTI will send invoices to Sponsor’s named point of contact
              (Registration 1) at the email provided. Payment terms are NET 30.
              Participant will not be obligated to pay RTI costs that exceed the
              amount authorized by the Registration Form.
            </p>
            <h4>CANCELLATION, REFUND, AND SUBSTITUTION POLICY</h4>
            <p>
              Conference sponsorship and related registration(s) may be
              cancelled up to thirty (30) calendar days before the Conference
              date by providing written notice of cancellation to RTI using the
              instructions on the Conference website. Provided the registered
              Sponsor cancels by written notice within the allowable timeframe,
              RTI will either 1) cancel the invoice, or 2) refund the sponsor
              fee to the entity who made payment on behalf of the Sponsor.
            </p>
            <p>
              Sponsors who provide written notice of cancellation thirty (30)
              days or less before the Conference date are not eligible for a
              refund. If the Conference registration fee has not been received
              by RTI, the entity responsible for making payment on behalf of the
              attendee shall be invoiced and payment shall be due.
            </p>
            <p>
              Substitutions of Sponsor’s registrants may be made up to seven (7)
              calendar days before the Conference. Substitutions must be made
              within the allowable timeframe by providing written notice using
              the instructions on the Conference website.
            </p>
            <p>The refund and cancellation policy will not be waived.</p>
            <p>
              In the event RTI must cancel the Conference due to unforeseen
              circumstances, RTI will refund the cost of registrations paid.
              However, RTI does not assume responsibility for any additional
              costs, charges, or expenses; to include, charges made for travel
              and lodging.
            </p>
            <h4>VISITOR TAGS</h4>
            <p>
              Sponsors will be issued a visitor tag upon entering the Benton
              Convention Center and signing in at the Registration Table.
              Sponsors will display the tags while attending the Conference.
              Tags are valid for named Sponsors only and cannot be transferred.
              Sponsors may be asked for photographic ID during the Conference.
              If Sponsor is unable to provide identification, which matches the
              tag, they may be asked to leave the Conference. Tags will expire
              at the end of the Conference. Sponsors will restrict themselves to
              the areas designated for the Conference and in accordance with the
              Conference schedule/agenda.
            </p>

            <h4>PHOTOGRAPHY, AUDIO AND VIDEO RECORDING</h4>
            <p>
              The Conference will be held at the Benton Convention Center, 301 W
              5th Street, Winston-Salem, NC 27101 (“Conference premises”). We
              prohibit participants, exhibitors, sponsors, news organizations
              and other companies from photographing or video or audio-taping
              some Conference activities. RTI reserves the right to use images
              taken at the Conference with your photograph and/or likeness in
              future marketing materials. RTI may edit, alter, copy, exhibit,
              distribute and publish in print, video, audio recorded
              productions, and on the World Wide Web material from the
              Conference for purposes of publicizing RTI programs or other
              lawful purpose without payment or any other consideration. The
              photography, audio and video recording will become the property of
              RTI, stored in a place chosen by RTI and will not be returned to
              me. In addition, I waive the right to inspect or approve the
              finished product, including written or electronic copy, wherein my
              likeness appears. I waive any right to royalties or other
              compensation arising or related to the use of the photography,
              audio and video recording.
            </p>
            <h4>ALCOHOL, DRUG, AND SMOKING DRUG POLICY</h4>
            <p>
              Alcohol will not be permitted on the Conference premises during
              the Conference. Participants found possessing or using illicit
              drugs, as defined by United States federal law, will be required
              to leave the Conference premises immediately and may be held
              criminally liable. RTI prohibits smoking on the Conference
              premises during the Conference.
            </p>
            <h4>VALUABLES</h4>
            <p>
              Participant is solely responsible for any valuables they decide to
              bring to the Conference. RTI is not responsible for belongings
              left on Conference premises.
            </p>
            <h4>LIABILITY</h4>
            <p>
              I, Sponsor, hereby release, waive liability, discharge, hold
              harmless, indemnify, and covenant not to sue the RTI or the Benton
              Convention Center for any and all liability incurred in the
              conduct of, and my participation in, this Conference.
            </p>
            <p>
              Participant will report any and all injuries to RTI and Benton
              Convention Center staff immediately. Should any medical emergency
              arise, Participant will first call 911.
            </p>
            <p>
              RTI executives are the only staff members empowered to grant
              exceptions to any Conference policies or other general RTI
              practices. I, Participant, will not hold RTI liable for any
              erroneous statements made by other staff members regarding
              exceptions to fees or policies. Purchase orders provided by the
              payee on behalf of the registered Participant are solely for
              accounting identification purposes. Any additional or conflicting
              terms and conditions contained within such purchase orders,
              acknowledgements, confirmations, or other communications by the
              Participant that are inconsistent with the RTI’s official terms
              and conditions for the Conference are hereby expressly rejected
              and will not be considered part of the agreement.
            </p>

            <div v-if="!viewOnly">
              <p>
                NAME: {{ name }}<br />

                DATE: {{ date }}
              </p>
              <div v-if="!accepted">
                <v-form ref="termsForm">
                  <v-checkbox required v-model="terms" :rules="rules.terms">
                    <template slot="label"
                      >By checking this box, you agree to the terms and
                      conditions.<span class="star">*</span></template
                    >
                  </v-checkbox>
                  <v-btn
                    class="ml-0"
                    color="primary"
                    @click="submitTerms()"
                    v-if="!submitted"
                    >Submit</v-btn
                  >
                  <v-progress-circular v-else indeterminate />
                </v-form>
              </div>
              <div v-else>
                <h4>Thank you!</h4>
                <p v-if="accepted_date">
                  You accepted the terms and conditions
                  <strong>{{ accepted_date | localTime }} ago</strong>.
                </p>
                <p>
                  Thank you for sponsoring the 2026 Early College Summit! Your
                  support plays a vital role in making this event impactful for
                  educators and those who are working to expand implementation
                  of early college high school as a successful model of
                  education innovation. Your generosity enables us to create a
                  meaningful experience for education professionals, and we are
                  truly grateful for your partnership.
                </p>
                <p>
                  Our team will be in touch for additional information for
                  summit communications. Please don’t hesitate to reach out if
                  you have any questions. We look forward to seeing you at the
                  Summit!
                </p>
                <p>
                  Frank McKay<br />
                  Director, Early College Network<br />
                  RTI International
                </p>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<style scoped lang="scss">
.terms-ecs-2025 {
  word-break: break-word;
  div {
    word-break: break-word;
  }
}
</style>

<script>
export default {
  data() {
    return {
      user: null,
      name: "",
      date: new Date().toLocaleDateString(),
      event: "",
      event_date: "",
      event_waiver: "default",
      terms: null,
      accepted: false,
      accepted_date: null,
      submitted: false,
      rules: {
        terms: [
          (v) => !!v || "You must accept the terms and conditions to continue."
        ]
      }
    };
  },
  methods: {
    submitTerms() {
      if (this.$refs.termsForm.validate()) {
        this.submitted = true;
        this.$http
          .put("registration/terms/" + this.user.uuid, { terms: 1 })
          .then((response) => {
            this.accepted = true;
            this.accepted_date = response.data.data[0].updated_at;
            this.$store.commit("updateMessage", {
              message: "The terms have been accepted.",
              snackbar: true
            });
          });
      }
    }
  },
  computed: {
    waiver: function () {
      // For now we assume that there are two flavors of waivers:
      // Default (on location) and virtual.
      switch (this.event_waiver.trim().toLowerCase()) {
        case "virtual":
          return "virtual";
        default:
          return "default";
      }
    },
    defaultWaiver: function () {
      return this.waiver === "default";
    },
    virtualWaiver: function () {
      return this.waiver === "virtual";
    },
    viewOnly: function () {
      // If no uuid is provided, then this is a view only mode.
      return !this.$route.params.uuid;
    }
  },
  mounted() {
    if (!this.$route.params.uuid) {
      return;
    }

    this.$http.get("registration/terms/" + this.$route.params.uuid).then(
      (response) => {
        this.user = response.data.data[0];
        this.name = this.user.name;
        this.event = this.user.registration.registration_event.name;
        this.event_date = this.user.registration.registration_event.dates;
        this.event_waiver =
          this.user.registration.registration_event.content.waiver || "default";
        if (this.user.terms) {
          this.terms = this.user.terms;
          this.accepted = true;
          this.accepted_date = this.user.updated_at;
        }
        this.$store.commit("updateMessage", {
          message: "Please review the terms and conditions.",
          snackbar: true
        });
      },
      (response) => {
        this.$store.commit("updateMessage", {
          message:
            "Error: Your information was not found. Please contact support.",
          snackbar: true
        });
        this.$router.push({ path: "/event/missing-token" });
      }
    );
  }
};
</script>
